import download from "downloadjs"

export enum RequestMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE"
}

export enum ContentType {
  FormUrlEncoded = "application/x-www-form-urlencoded;charset=UTF-8",
  ApplicationJson = "application/json",
  MultipartFormData = "multipart/form-data"
}

interface RequestOptions {
  signal?: RequestInit['signal']
  body?: any
  method?: RequestMethod
  contentType?: ContentType
}

function objectToUrlEncoded(element, key?, list?) {
  list = list || []

  if (typeof (element) == 'object') {
    for (const idx in element) {
      objectToUrlEncoded(element[idx], key ? key + '[' + idx + ']' : idx, list)
    }
  } else {
    list.push(key + '=' + encodeURIComponent(element));
  }

  return list.join('&');
}

function objectToFromData(data: any) {
  const formData = new FormData()

  for (const name in data) {
    formData.append(name, data[name])
  }

  return formData
}

const bodyBuilderStrategy: { [id: string]: (body: any) => any } = {
  [ContentType.FormUrlEncoded]: (body: any) => {
    return objectToUrlEncoded(body)
  },
  [ContentType.ApplicationJson]: (body: any) => {
    return JSON.stringify(body)
  },
  [ContentType.MultipartFormData]: (body: any) => {
    return objectToFromData(body)
  }
}

export const fetcher = async (url: string, options: RequestOptions = {}): Promise<any> => {
  const body: string = bodyBuilderStrategy[options.contentType](options.body)

  const headers = {
    // This was added for backward compatibility with \WebApp\Controllers\BaseController.cs IsAjaxRequest property.
    // This property was used to determine wheather the request was made via JS or via HTML form.
    'X-Requested-With': 'XMLHttpRequest',
    'Version-Frontend': window.SENTRY_RELEASE
  }

  if (options.contentType != ContentType.MultipartFormData) {
    headers['Content-Type'] = options.contentType
  }

  const res = await fetch(url, {
    ...options,
    headers,
    body
  })

  if (res.status === 401) {
    window.location.reload()
    return Promise.resolve()
  }

  if (res.status === 204 || res.status === 304) {
    return Promise.resolve()
  }

  if (res.headers.get('Content-Type')?.indexOf('application/pdf') > -1) {
    const blob = await res.blob()
    // workaround to get file name
    const fileName = res.headers.get('Content-Disposition').match(/filename="(.+)"/)[1];
    return download(blob, fileName)
  }

  let data = await res.text()

  if (res.headers.get('Content-Type')?.indexOf('application/json') > -1 && data) {
    data = JSON.parse(data)
  }

  if (res.status >= 400 && res.status < 600) {
    return Promise.reject({ status: res.status, data, headers: res.headers })
  }

  return data
}
